// extracted by mini-css-extract-plugin
export default {"page":"Ammw5xppp1SeeZahpmBM"};